import { render, staticRenderFns } from "./CommunityGroupDescription.vue?vue&type=template&id=f26e1b16&"
import script from "./CommunityGroupDescription.vue?vue&type=script&lang=ts&"
export * from "./CommunityGroupDescription.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports